export const products = [
    {
      id: 1,
      name: "BHUFER-S INJECTION",
      category: "Iron Supplement / Speciality",
      image: "/assets/product/p10.10.png",
      description: "BHUFER-S Injection is an advanced iron supplement designed for medical use.",
      ingredients: [
        "Active Ingredient: Ferric hydroxide in complex with Sucrose",
        "Elemental Iron: 20mg per mL",
        "Solvent: Water for Injection (Q.S.)"
      ],
      packaging: [
        "Dosage Form: 5mL Vial in a monocarton",
        "Master Pack: 10 monocartons in a box"
      ],
      benefits: [
        "Provides essential iron supplementation",
        "Supports patients with iron deficiency",
        "Clinically tested and safe for medical use"
      ],
      usage: "Administer as prescribed by a healthcare professional. Suitable for hospital and clinical use.",
      storage: [
        "Store in a cool, dry place away from direct sunlight.",
        "Keep out of reach of children."
      ],
      safety: [
        "Use under medical supervision.",
        "Not intended for self-medication."
      ]
    },
    {
      id: 2,
      name: "BHUGEST 200SR",
      category: "Pregnancy Management / Infertility",
      image: "/assets/product/p4.4.png",
      description: "BHUGEST 200SR is a sustained-release progesterone tablet designed to support pregnancy management and infertility treatments.",
      ingredients: [
        "Active Ingredient: Progesterone Sustain Release 200mg"
      ],
      packaging: [
        "Dosage Form: Strip of 10 tablets in Monocarton",
        "Master Pack: 1 x 10 tablets in Monocarton, 10 Monocartons in a Box"
      ],
      benefits: [
        "Supports pregnancy maintenance",
        "Helps in infertility treatment",
        "Ensures sustained progesterone release"
      ],
      usage: "Take as prescribed by a healthcare professional. Do not self-medicate.",
      storage: [
        "Store in a cool, dry place away from direct sunlight.",
        "Keep out of reach of children."
      ],
      safety: [
        "Use under medical supervision.",
        "Not intended for self-medication."
      ]
    },
    {
      id: 3,
      name: "BHUGEST DY 10",
      category: "Pregnancy Management / Infertility",
      image: "/assets/product/p3.3.png",
      description: "BHUGEST DY 10 is a specialized Dydrogesterone tablet designed for pregnancy management and infertility treatment.",
      ingredients: [
        "Active Ingredient: Dydrogesterone 10mg"
      ],
      packaging: [
        "Dosage Form: Strip of 10 tablets",
        "Master Pack: 1 x 10 tablets in Monocarton, 10 Monocartons in a Box"
      ],
      benefits: [
        "Supports pregnancy maintenance",
        "Aids in infertility treatment",
        "Provides hormonal balance during pregnancy"
      ],
      usage: "Take as prescribed by a healthcare professional. Do not self-medicate.",
      storage: [
        "Store in a cool, dry place away from direct sunlight.",
        "Keep out of reach of children."
      ],
      safety: [
        "Use under medical supervision.",
        "Not intended for self-medication."
      ]
    },
    {
      id: 4,
      name: "BHULETRA 2.5mg",
      category: "Pregnancy Management / Infertility",
      image: "/assets/product/p6.6.png",
      description: "BHULETRA 2.5mg is a Letrozole tablet used in infertility treatment and pregnancy management.",
      ingredients: [
        "Active Ingredient: Letrozole 2.5mg"
      ],
      packaging: [
        "Dosage Form: Strip of 10 tablets",
        "Master Pack: 10 x 10 tablets in a Box"
      ],
      benefits: [
        "Helps in ovulation induction",
        "Supports fertility treatment",
        "Used in hormone therapy"
      ],
      usage: "Take as prescribed by a healthcare professional. Do not self-medicate.",
      storage: [
        "Store in a cool, dry place away from direct sunlight.",
        "Keep out of reach of children."
      ],
      safety: [
        "Use under medical supervision.",
        "Not intended for self-medication."
      ]
    },
    {
      id: 5,
      name: "DUROPAT 25mg",
      category: "Pregnancy Management / Infertility",
      image: "/assets/product/p7.7.png",
      description: "DUROPAT 25mg is a specialized medication used in pregnancy management and infertility treatments. It contains Sildenafil Citrate 25mg, which helps in improving blood flow to reproductive organs.",
      ingredients: [
        "Active Ingredient: Sildenafil Citrate 25mg"
      ],
      packaging: [
        "Dosage Form: Strip of 10 tablets",
        "Master Pack: 10 x 10 Tablet strips in a box"
      ],
      benefits: [
        "Helps in pregnancy management",
        "Improves blood flow for reproductive health",
        "Trusted medical-grade formulation"
      ],
      usage: "Take as prescribed by a healthcare professional. Do not exceed the recommended dose.",
      storage: [
        "Store in a cool, dry place away from direct sunlight.",
        "Keep out of reach of children."
      ],
      safety: [
        "Use under medical supervision.",
        "Not intended for self-medication."
      ]
    },
    {
      id: 6,
      name: "MPFID SOFT GELATIN CAPSULE",
      category: "Pregnancy Management / Infertility",
      image: "/assets/product/p1.1.png",
      description: "MPFID Soft Gelatin Capsule is a nutritional supplement designed for pregnancy management and infertility treatment. It provides essential vitamins and minerals required during pregnancy.",
      ingredients: [
        "Methylcobalamin: 1500 mcg",
        "Pyridoxal-5 Phosphate: 3 mg",
        "L-Methylfolate Calcium: 0.5 mg",
        "Vitamin D3: 2000 IU",
        "DHA (40%): 200 mg"
      ],
      packaging: [
        "Dosage Form: Strip of 10 soft gelatin capsules",
        "Master Pack: 10 monocartons in a box"
      ],
      benefits: [
        "Supports fetal development",
        "Helps in pregnancy management",
        "Provides essential vitamins and DHA"
      ],
      usage: "Take as prescribed by a healthcare professional. Do not exceed the recommended dose.",
      storage: [
        "Store in a cool, dry place away from direct sunlight.",
        "Keep out of reach of children."
      ],
      safety: [
        "Use under medical supervision.",
        "Not intended for self-medication."
      ]
    },
    {
        id: 7,
        name: "RADOPAT DSR",
        category: "Acidity Treatment / General",
        image: "/assets/product/p11.11.png",
        description: "RADOPAT DSR is a combination medication used for treating acidity and gastroesophageal reflux disease (GERD). It contains Rabeprazole sodium and Domperidone, which help reduce acid production and improve digestion.",
        ingredients: [
          "Rabeprazole Sodium IP (Enteric Coated Tablet): 20 mg",
          "Domperidone IP (Immediate Release Tablet): 10 mg",
          "Domperidone IP (Sustained Release Tablet): 20 mg"
        ],
        packaging: [
          "Dosage Form: Strip of 10 soft capsules",
          "Master Pack: 10 x 10 capsule strips in a box"
        ],
        benefits: [
          "Reduces stomach acid production",
          "Helps in acid reflux and indigestion",
          "Relieves symptoms of nausea and bloating"
        ],
        usage: "Take as prescribed by a healthcare professional. Do not exceed the recommended dose.",
        storage: [
          "Store in a cool, dry place away from direct sunlight.",
          "Keep out of reach of children."
        ],
        safety: [
          "Use under medical supervision.",
          "Not intended for self-medication."
        ]
      },
      {
        id: 8,
        name: "RAYPAT D3",
        category: "Vitamins / Speciality",
        image: "/assets/product/p9.9.png",
        description: "RAYPAT D3 is a vitamin supplement used to treat Vitamin D deficiency and support bone health. It contains Cholecalciferol (Vitamin D3) in Nano Droplet form, which enhances absorption and effectiveness.",
        ingredients: [
          "Cholecalciferol IP (Vitamin D3): 60000 IU",
          "Form: Nano Droplet for better absorption"
        ],
        packaging: [
          "Dosage Form: Ready-to-Drink Solution (5mL)",
          "Master Pack: Pack of 4 bottles in a box"
        ],
        benefits: [
          "Helps in Vitamin D deficiency",
          "Supports strong bones and immune health",
          "Fast absorption with Nano Droplet technology"
        ],
        usage: "Take as prescribed by a healthcare professional. Shake well before use.",
        storage: [
          "Store in a cool, dry place away from direct sunlight.",
          "Keep out of reach of children."
        ],
        safety: [
          "Use under medical supervision.",
          "Not intended for self-medication."
        ]
      },
      {
        id: 9,
        name: "VOLOVIT A+",
        category: "Pregnancy Management / Infertility",
        image: "/assets/product/p2.2.png",
        description: "VOLOVIT A+ is a nutritional supplement designed for pregnancy management and infertility support. It contains essential amino acids, vitamins, and minerals that contribute to healthy fetal development and maternal well-being.",
        ingredients: [
          "L-Leucine: 18.3mg",
          "L-Isoleucine: 5.9mg",
          "L-Lysine HCl: 25.0mg",
          "L-Phenylalanine: 5.0mg",
          "L-Threonine: 8.3mg",
          "L-Valine: 6.7mg",
          "L-Tryptophan: 8.3mg",
          "L-Methionine: 10.1mg",
          "Copper Sulphate Pentahydrate: 18.4mg",
          "Light Magnesium Oxide: 30mg",
          "Selenium (as Selenium Dioxide Monohydrate): 75mcg"
        ],
        packaging: [
          "Dosage Form: Strip of 10 tablets in monocarton",
          "Master Pack: 10 Monocartons in a Box"
        ],
        benefits: [
          "Supports maternal health during pregnancy",
          "Provides essential amino acids for fetal growth",
          "Aids in overall reproductive health",
          "Helps reduce pregnancy-related deficiencies"
        ],
        usage: "Take as directed by a healthcare professional. Do not exceed the recommended dosage.",
        storage: [
          "Store in a cool, dry place away from direct sunlight.",
          "Keep out of reach of children."
        ],
        safety: [
          "Consult your doctor before use, especially during pregnancy.",
          "Not intended for self-medication."
        ]
      },
      {
        id: 10,
        name: "VOLOVIT-F",
        category: "Pregnancy Management / Infertility",
        image: "/assets/product/p5.5.png",
        description: "VOLOVIT-F is a premium nutritional supplement formulated for pregnant women to support fertility, pregnancy health, and overall maternal well-being. It contains essential L-Arginine, Folic Acid, Coenzyme Q10, Lycopene, Piperine, and Vitamin B12 to promote optimal fetal development and maternal health.",
        ingredients: [
          "L-Arginine (500mg): Improves blood circulation and supports fetal growth",
          "Folic Acid (500mcg): Helps prevent neural tube defects in the baby",
          "Pyridoxine Hydrochloride (1.5mg): Supports metabolism and brain function",
          "Coenzyme Q10 (15mg): Boosts energy production and supports heart health",
          "Vitamin B12 (2.5mcg): Essential for nerve function and red blood cell production",
          "Lycopene (2.5mg): A powerful antioxidant that protects against cell damage",
          "Piperine (2.5mg): Enhances nutrient absorption for maximum benefits"
        ],
        packaging: [
          "Dosage Form: Strip of 10 soft gelatin capsules",
          "Master Pack: 10 Monocartons in a Box"
        ],
        benefits: [
          "Enhances blood flow to the uterus and placenta",
          "Supports healthy fetal development",
          "Reduces the risk of pregnancy complications",
          "Provides essential nutrients for maternal well-being",
          "Aids in cell regeneration and energy production"
        ],
        usage: "Take one capsule daily or as directed by your healthcare provider. Best taken with meals.",
        storage: [
          "Store in a cool, dry place, away from direct sunlight.",
          "Keep the pack tightly closed after use."
        ],
        safety: [
          "Consult your doctor before use, especially during pregnancy.",
          "Not intended for self-medication."
        ]
      },
      {
        id: 11,
        name: "VOLOVIT PRO",
        category: "Pregnancy Management / Infertility",
        image: "/assets/product/p8.8.png",
        description: "VOLOVIT PRO is a scientifically formulated protein supplement designed for pregnant women and new mothers. It contains 36 essential nutrients, 24% protein, and key ingredients such as DHA, GLA, and Cow Colostrum to support maternal and fetal health.",
        ingredients: [
          "High-Quality Protein: 24% protein content for muscle strength",
          "DHA (Docosahexaenoic Acid): Supports brain and vision development",
          "GLA (Gamma-Linolenic Acid): Aids in hormone balance",
          "Cow Colostrum: Strengthens immunity and provides essential antibodies",
          "36 Essential Nutrients: Vital vitamins and minerals for pregnancy care"
        ],
        packaging: [
          "Dosage Form: 200g Protein Powder Jar"
        ],
        benefits: [
          "Supports healthy fetal growth",
          "Provides balanced nutrition for pregnancy",
          "Enhances energy levels and overall well-being",
          "Strengthens immune system and bone health"
        ],
        usage: "Mix one scoop (as directed) in a glass of milk or water. Consume daily or as recommended by a healthcare professional.",
        storage: [
          "Store in a cool, dry place, away from direct sunlight.",
          "Keep the jar tightly closed after use."
        ],
        safety: [
          "Consult your doctor before use, especially during pregnancy.",
          "Not intended for self-medication."
        ]
      },
      {
  "id": 12,
  "name": "Monareel LNG IUD",
  "category": "Contraception / Intrauterine Device",
  "image": "/assets/product/p12.12.jpg",
  "description": "Monareel LNG IUD is a long-acting, reversible hormonal intrauterine device that releases Levonorgestrel (LNG) to provide effective contraception. It is designed for women seeking safe, low-maintenance birth control with additional benefits like reduced menstrual bleeding.",
  "ingredients": [
    "Levonorgestrel (LNG): 52mg hormonal component released gradually",
    "Polyethylene Frame: Flexible T-shaped structure for uterine placement",
    "Barium Sulfate: Allows X-ray visibility",
    "Silicone: Coating for smooth insertion"
  ],
  "packaging": [
    "Sterile single-unit blister pack with inserter device"
  ],
  "benefits": [
    "Up to 99% effective contraception for 3-5 years",
    "Reduces menstrual blood loss (therapeutic for heavy periods)",
    "Localized hormone release (minimal systemic side effects)",
    "Fertility returns quickly after removal"
  ],
  "usage": "Inserted into the uterus by a trained healthcare professional during a clinic visit. Requires follow-up after 4-6 weeks to check placement.",
  "storage": [
    "Store below 30°C in original packaging until use",
    "Do not resterilize or expose to moisture"
  ],
  "safety": [
    "Contraindicated in active pelvic infections or unexplained bleeding",
    "Risk of expulsion or perforation (rare)",
    "May cause irregular spotting in first 3-6 months",
    "Requires professional insertion/removal"
  ]
},
{
  "id": 13,
  "name": "RayPat-CAL",
  "category": "Bone Health / Calcium Supplement",
  "image": "/assets/product/p13.13.jpg",
  "description": "RayPat-CAL is an advanced calcium and vitamin D3 formulation designed to support strong bones, teeth, and muscle function. It combines highly bioavailable calcium carbonate with vitamin D3 for optimal absorption, making it ideal for individuals with dietary deficiencies, osteoporosis risk, or increased calcium needs (e.g., pregnancy, aging).",
  "ingredients": [
    "Calcium Carbonate (500mg elemental calcium per tablet)",
    "Vitamin D3 (Cholecalciferol, 400 IU per dose)",
    "Microcrystalline Cellulose (binder)",
    "Magnesium Stearate (lubricant)",
    "Optional: May contain trace minerals like zinc or magnesium"
  ],
  "packaging": [
    "Dosage Form: 60 tablets/bottle",
    "Blister packs (10 tablets per strip)"
  ],
  "benefits": [
    "Prevents calcium deficiency and osteoporosis",
    "Enhances bone density and reduces fracture risk",
    "Supports nerve transmission and muscle contraction",
    "Vitamin D3 improves calcium absorption"
  ],
  "usage": "Take 1-2 tablets daily with meals, or as directed by a physician. Swallow whole with water.",
  "storage": [
    "Store below 30°C in a dry place",
    "Protect from moisture and sunlight"
  ],
  "safety": [
    "Consult a doctor if you have kidney stones or hypercalcemia",
    "May interact with certain antibiotics or diuretics",
    "Excessive doses can cause constipation or toxicity"
  ]
},
{
  "id": 14,
  "name": "Bhugest-AQ 50",
  "category": "Fertility Treatment / Hormonal Therapy",
  "image": "/assets/product/p14.14.jpg",
  "description": "Bhugest-AQ 50 is a natural micronized progesterone injection formulated in water for superior bioavailability. Designed to support early pregnancy and fertility treatments, it achieves 3x greater plasma concentration than traditional oily progesterone with minimal side effects.",
  "ingredients": [
    "Progesterone (Natural Micronized): 50 mg/mL",
    "Water for Injection: Solvent base for enhanced absorption"
  ],
  "packaging": [
    "Dosage Form: 1 mL ampoules",
    "Pack Size: 10 ampoules/box"
  ],
  "benefits": [
    "High bioavailability: 3x greater plasma concentration vs. oily progesterone",
    "Reduced side effects (no oily injection discomfort)",
    "Supports uterine lining for IVF/GIFT implantation",
    "Safe for long-term use (up to 10 weeks)"
  ],
  "usage": "Administer 1 mL (50 mg) intramuscularly once daily, typically until 12 weeks of confirmed pregnancy. Follow physician guidance for IVF/GIFT protocols.",
  "storage": [
    "Store below 25°C in original packaging",
    "Protect from light and freezing"
  ],
  "safety": [
    "Contraindicated in active thromboembolic disorders",
    "Monitor for rare allergic reactions",
    "Not for self-administration—requires medical supervision"
  ],
  "indications": [
    "Luteal phase support in assisted reproductive technologies (IVF/GIFT)",
    "Threatened or recurrent miscarriage prevention",
    "Hormonal replacement therapy (as prescribed)"
  ]
}
  ];